import { ThumbsDown, ThumbsUp } from 'lucide-react';

import { Button } from '@/components/Button/Button';

import type { AIHomeworkVoteState } from './aiHomeworkTypes';
import styles from './VoteButtons.module.css';

interface VoteButtonsProps {
  downvotes: number;
  onDownvote: () => void;
  onUpvote: () => void;
  upvotes: number;
  vote: AIHomeworkVoteState;
}

export function VoteButtons({
  downvotes,
  onDownvote,
  onUpvote,
  upvotes,
  vote,
}: VoteButtonsProps) {
  const hasVoted = vote.userVote !== null;

  return (
    <div className={styles.group} aria-label="Rate this AI response">
      <span className={styles.label}>Was this helpful?</span>
      <Button
        aria-label={`Thumbs up. ${upvotes} upvotes`}
        aria-pressed={vote.userVote === 'up'}
        className={styles.button}
        data-selected={vote.userVote === 'up' ? 'true' : 'false'}
        disabled={vote.isVoting || hasVoted}
        onClick={onUpvote}
        size="small"
        variant="ghost"
      >
        <ThumbsUp aria-hidden="true" size={14} />
        {upvotes}
      </Button>
      <Button
        aria-label={`Thumbs down. ${downvotes} downvotes`}
        aria-pressed={vote.userVote === 'down'}
        className={styles.button}
        data-selected={vote.userVote === 'down' ? 'true' : 'false'}
        disabled={vote.isVoting || hasVoted}
        onClick={onDownvote}
        size="small"
        variant="ghost"
      >
        <ThumbsDown aria-hidden="true" size={14} />
        {downvotes}
      </Button>
      {vote.error ? (
        <p className={styles.error} role="alert">
          {vote.error}
        </p>
      ) : null}
    </div>
  );
}
